import { gql, useMutation } from '@apollo/client';

export const REGISTER_USER_FINFOLIO = gql`
    mutation registerUserFinfolio($data: userData!) {
        registerUserFinfolio (data: $data)
    }
`;

export default () => useMutation(REGISTER_USER_FINFOLIO);
